import { API, fetcher } from "@/shared/core-configs";

export const voucherApi = {
  getVoucherPDF: async (id: string) => {
    const response = await fetcher.get(
      `${API.GESLUB_SERVICE}/voucher/${id}/download`,
      {
        responseType: "blob",
      },
    );
    if (!response) {
      throw new Error("Error al obtener el voucher");
    }
    return response.data;
  },
  exportVouchersExcel: async (params: string) => {
    const response = await fetcher.get(
      `${API.GESLUB_SERVICE}/voucher/export-excel?${params}`,
      { responseType: "blob" },
    );
    if (!response) {
      throw new Error("Error al exportar vales a Excel");
    }
    return response.data;
  },
  sendEmailVoucher: async (id: string, emails?: string[]) => {
    const response = await fetcher.post(
      `${API.GESLUB_SERVICE}/voucher/${id}/send-email`,
      {
        emails,
      },
    );
    if (!response) {
      throw new Error("Error al enviar el voucher por correo");
    }
    return response.data;
  },
  getVouchersPDF: async (ids: string[]) => {
    const response = await fetcher.post(
      `${API.GESLUB_SERVICE}/voucher/bulk/download`,
      { ids },
      { responseType: "blob" },
    );
    return response.data as Blob;
  },
  sendEmailVouchers: async (ids: string[], emails?: string[]) => {
    const response = await fetcher.post(
      `${API.GESLUB_SERVICE}/voucher/bulk/send-email`,
      { ids, emails },
    );
    return response.data as { sent: number };
  },
};
